import React from 'react';

import {Container} from 'Components/Utilities';
import PushNotifications from 'Components/Partials/PushNotifications';
// import SupportTicketButton from 'Components/Networking/SupportTicketButton';

import Header from './Header';

export default class Authenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {children, title} = this.props;

        return (
            <div className="min-h-screen font-light flex flex-col justify-between bg-blobs bg-cover bg-top">
                <div>
                    <Header />

                    {window.base.features.support_tickets && <SupportTicketButton/>}

                    {window.base.features.allow_push_notifications && <PushNotifications />}

                    <Container>
                        {children}
                    </Container>
                </div>

               {/* <div className="text-white bg-app-blue-dark px-8 py-4">
                    <a href="https://www.boots.com/floating-editorial/editorial-legal/privacypolicy" target="_blank">
                        Privacy Policy
                    </a>
                </div>*/}
            </div>
        )
    };
}
